module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-rounded-IJXIJK3M.woff?beab399e036b4f8497d01c87a2998100";